import Vue from 'vue';
Vue.directive('schema', {
    bind: function (el, binding) {
        var schemaConfig = binding.value;
        Object.keys(schemaConfig).forEach(function (key) {
            if (schemaConfig[key] === true) {
                el.setAttribute("item".concat(key), '');
            }
            else if (key === 'type') {
                el.setAttribute("itemtype", 'http://schema.org/' + schemaConfig[key]);
            }
            else {
                el.setAttribute("item".concat(key), schemaConfig[key]);
            }
        });
    }
});
